<template>
  <div class="space-y-8 divide-y divide-gray-200">
    <div class="my-6 grid grid-cols-1 gap-y-4 gap-x-2 sm:grid-cols-4">
      <template v-for="s in search" :key="s.id">
        <template v-if="s.type == 'input'">
          <div class="col-span-1">
            <m-input
              class="
                shadow-sm
                focus:ring-0
                block
                w-full
                sm:text-sm
                border-gray-300
              "
              :id="s.id"
              :name="s.name"
              v-model="form[s.model]"
              :placeholder="$t('message.' + s.placeholder)"
              @keyup.enter="$emit('search')"
            ></m-input>
          </div>
        </template>

        <template v-if="s.type == 'datetime'">
          <div class="col-span-1">
            <v-date-picker
              name="s.name"
              v-model="form[s.model]"
              value-type="date"
              :placeholder="$t('message.' + s.placeholder)"
              lang="en"
              format="dd/MM/yyyy"
            ></v-date-picker>
          </div>
        </template>

        <template v-else-if="s.type == 'select'">
          <div v-if="s.model == 'branch'" class="col-span-1">
            <select
              class="
                shadow-sm
                block
                focus:ring-0
                w-full
                sm:text-sm
                border-gray-300
                rounded-md
              "
              :name="s.name"
              :id="s.id"
              autocomplete="branch-name"
              v-model="form[s.model]"
            >
              <option :value="'YGN'" :selected="form[s.model] == 'YGN'">
                ၄၉လမ်း(ရန်ကုန်)
              </option>
              <option :value="'MDY'" :selected="form[s.model] == 'MDY'">
                မန္တလေးရုံးခွဲ
              </option>
            </select>
          </div>
          <div v-else-if="s.model == 'tracking_status'" class="col-span-1">
            <multiselect
              ref="statusSelect"
              v-model="form[s.model]"
              :multiple="false"
              :options="status.list"
              :track-by="status.key"
              :label="status.bvalue"
              :close-on-select="true"
              :clear-on-select="true"
              :searchable="true"
              :allow-empty="true"
              :taggable="true"
              :show-labels="false"
              :placeholder="$t('message.status')"
              class="
                shadow-sm
                focus:ring-0
                block
                sm:text-sm
                border-gray-300
                rounded-md
              "
            ></multiselect>
          </div>
        </template>
      </template>

      <template v-if="isSearch || isReset">
        <div class="col-span-1 flex items-center">
          <button
            v-if="isSearch"
            class="
              inline-flex
              items-center
              justify-center
              px-4
              py-2
              border border-transparent
              text-sm
              font-medium
              rounded
              shadow-sm
              text-white
              bg-green-500
              hover:bg-green-600
              focus:outline-none focus:ring-0
              mr-2
            "
            @click.prevent="$emit('search')"
          >
            <SearchIcon class="h-5 w-5 mx-1" aria-hidden="true" />
            {{ $t("message.search") }}
          </button>

          <RefreshIcon
            v-if="isReset"
            class="
              cursor-pointer
              inline-flex
              items-center
              px-3
              py-2
              w-12
              border border-transparent
              text-xs
              font-xs
              rounded
              shadow-sm
              text-red-600
              bg-gray-100
              hover:bg-gray-200
              focus:outline-none focus:ring-0
            "
            v-tooltip="$t('message.reset')"
            @click.prevent="$emit('reset')"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { RefreshIcon, SearchIcon } from "@heroicons/vue/solid";
import { watch, computed, ref, reactive, onMounted } from "vue";
import constants from "Resources/config/constants.js";
import { trans, locale, i18n } from "Resources/plugins/i18n";
import helper from "Resources/util/helper";
import datePickerSetting from "Resources/config/datePicker.json";

export default {
  name: "Search",
  components: {
    RefreshIcon,
    SearchIcon,
  },
  props: ["search", "form", "actions", "status", "reset"],

  setup(props) {
    const isSearch = computed(() => {
      return props.actions.search;
    });

    const statusList = [
      constants.label_status_enum.PENDING,
      constants.label_status_enum.ACCEPT_FROM_ORIGIN_BRANCH,
      constants.label_status_enum.SEND_TO_MMPOST,
      constants.label_status_enum.SEND_TO_DESTINATION_BRANCH,
      constants.label_status_enum.ARRIVED_TO_DESTINATION_BRANCH,
      constants.label_status_enum.SEND_TO_DESTINATION_ADDRESS,
      constants.label_status_enum.DELIVERED,
      constants.label_status_enum.SENDBACK_TO_ORIGIN_ADDRESS,
      constants.label_status_enum.SENTBACK_TO_CUSTOMER,
      constants.label_status_enum.SENDBACK_TO_DESTINATION_BRANCH,
      constants.label_status_enum.ARRIVEDBACK_TO_DESTINATION_BRANCH,
      constants.label_status_enum.SENDBACK_TO_ORIGIN_BRANCH,
      constants.label_status_enum.ARRIVED_TO_ORIGIN_BRANCH,
      constants.label_status_enum.RETURN_CONFIRMED,
      constants.label_status_enum.PICKUP_COURIER_LEADER,
      constants.label_status_enum.PICKUP_COURIER,
      constants.label_status_enum.POSTMAN_HAND_OVER,
    ];

    const status = reactive({
      list: [],
      type: "lang",
      bkey: "status",
      bvalue: "status",
    });

    const statusSelect = ref(null);

    const isReset = computed(() => {
      console.log(props.reset);
      return props.actions.reset;
    });

    onMounted(() => {
      console.log(i18n.locale, locale)
      prepareStatusSelect();
    });

    watch(() => {
      
    });

    const prepareStatusSelect = () => {
      let list = statusList.map((status) => {
        return {
          id: status,
          status: trans(status),
        };
      });

      let select = status;

      helper.assignObject({ list: list }, select);

      Object.assign(status, select);
      if (statusSelect.value) {
        statusSelect.value.chosenUpdate();
      }
    };

    return {
      isSearch,
      isReset,
      status
    };
  },
};
</script>